        
import React from 'react';

import Advantagespla from './Advantagespla';
import Advantagpallets from './Advantagpallets';


const Advantagesps = () => {
    return (
        <div>
        <Advantagespla />
            <Advantagpallets />

        </div>
    );
};

export default Advantagesps;
